import { generatePalette } from './app/pages/themes/themeService';

export function initializeTheme(): () => Promise<void> {
  return () => {
    return new Promise<void>((resolve) => {
      const savedColor = localStorage.getItem('user-theme-color');
      if (savedColor) {
        applyTheme(savedColor);
        resolve();
        return;
      }
      applyTheme('#3B82F6');
      resolve();
    });
  };
}

export function applyTheme(color: string): void {
  const palette = generatePalette(color);
  Object.entries(palette).forEach(([key, value]) => {
    document.documentElement.style.setProperty(`--p-primary-${key}`, value);
  });
}
